/* Dashboard display helpers — money/week formatting + chart palette.
   Money maths delegate to the single source of truth in src/helper.js. */
import { formatAmount } from '../../../helper';
import { COLORS } from '../shared/tokens';

/** "£1234.56" — full-precision money for tables. */
export function gbp(value) {
    return `£${formatAmount(value)}`;
}

/** "£415.4k" / "£1.20m" — compact money for headline KPIs. */
export function gbpCompact(value) {
    const n = Number(value) || 0;
    const a = Math.abs(n);
    if (a >= 1e6) return `£${formatAmount((n / 1e6))}m`;
    if (a >= 1e3) return `£${(n / 1e3).toFixed(1)}k`;
    return `£${formatAmount(n)}`;
}

/** "2025-W41" → "W41" for compact chart axes. */
export function shortWeek(code) {
    if (!code) return '';
    const parts = String(code).split('-W');
    return parts[1] ? `W${parts[1]}` : String(code);
}

/** Series colours for the cash/card/other split (crimson / blue / ochre). */
export const SERIES = {
    cash:  COLORS.primary,
    card:  '#2563eb',
    other: '#c99a2e',
};

/** Map a repair/sale status to a chart colour, aligned with StatusChip semantics. */
export function statusColor(status) {
    const s = String(status || '').trim().toLowerCase();
    if (['finish', 'finished', 'complete', 'completed', 'approved', 'done', 'paid'].includes(s)) return '#15803d';
    if (['in process', 'in-process', 'pending', 'processing', 'request', 'requested', 'hold'].includes(s)) return '#a16207';
    if (['refund', 'refunded', 'ber', 'failed', 'rejected', 'cancelled', 'unpaid'].includes(s)) return '#b91c1c';
    if (['available', 'new', 'open', 'info'].includes(s)) return '#1d4ed8';
    return '#64748b';
}

/** A palette for categorical donuts (stock types, etc.). */
export const CATEGORY_PALETTE = ['#a32f2f', '#2563eb', '#15803d', '#c99a2e', '#7c3aed', '#0891b2'];
